import request from "@/global/request/request";
import API from "@/global/request/api";

// const platformConfig = {
//   headers: {
//     "Platform-Id": "jiker_fuwu_admin"
//   }
// };

// const authService = {
//   authPermissions() {
//     return request.get(API.authPermissions, {}, platformConfig);
//   }
// };

const authService = {
  authPermissions() {
    return request.get(API.authPermissions);
  }
};

export default authService;
